import React, { useEffect, useState } from 'react'
import StaticUtils from '../../../utils/StaticUtils'
import { convertHoursToMins, convertTimeFormat, getProcureInfo, goToLPDetailUtil, redirectToPageUtil, SessionKeys } from '../../../utils/AppUtils'
import API_LIST from '../../../utils/apiList'
import CONFIG from '../../../utils/config'
import axios from 'axios'
import { t } from 'i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import NotFoundComponent from '../../../components/NewDesign/NotFound/NotFoundComponent'
import ProductCardFinwell from './ProductCardFinwell'

const CalculatorCard = (props) => {
  const { activeTab='all', selectedCategory=[], selectedSubcategory=[], setIsLoading=()=>{} ,from} = props
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [calcData, setCalcData] = useState([]);
  const [courseData, setCourseData] = useState({});
  useEffect(() => {
    getCalcData();
  }, [activeTab, selectedCategory, selectedSubcategory])
  const getCalcData = async () => {
    try {
      setIsLoading(true)
      const url = `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_CALC_DATA}`
      const selectedCate = selectedCategory.map(v => v.value)
      const selectedSubCate = selectedSubcategory.map(v => v.value)
      const payload = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        category_id: [...selectedCate, ...selectedSubCate],
        provider_id: "",
        search: "",
        sort: 1,
        page_size: 100,
        page: 1,
        pillar_id: activeTab === 'all' ? '' : activeTab,
        asset_id: '',
      }
      const res = await axios.post(url, payload)
      console.log(res)
      if (res.data?.data?.courseList) {

        let cList = res.data?.data?.courseList;

        for (let course of cList) {
          if (course.durationUnit === "Hours") {
            course.duration = convertHoursToMins(course.duration);
          }
          course.duration = convertTimeFormat(course.duration, true);
          course.durationUnit = "";
        }

        let prodArr = [];
        for (let course of cList) {
          let tags = [];
          let btnTitle = t("Start course");
          if (course.provider?.provider_display_name) {
            tags.push(course.provider.provider_display_name);
          }
          tags.push("Course");
          if (course.lessons) {
            tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
          }
          if (course.duration) {
            tags.push(`${course.duration} ${course.durationUnit}`);
          }
          if (course.views) {
            tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
          }
          if (course.crs_progress > 0 && course.crs_progress < 100) {
            btnTitle = t("Resume course");
          } else if (course.crs_progress >= 100) {
            btnTitle = t("Revisit course");
          }
          let priceInfo = getProcureInfo(course.purchased_info);
          course.is_home = true;
          setCalcData([]);
          prodArr.push({
            id: course?.courseId,
            is_like: course?.is_like ? course?.is_like : false,
            is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
            dbId: course?.list_id,
            productType: course?.typ,
            productOrigin: course?.source,
            title: course.name,
            logoURL: course.provider?.provider_img
              ? course.provider?.provider_img
              : "",
            bannerURL: course.imageURL,
            tagsArray: tags,
            description: course.short_description,
            btnTitle: btnTitle,
            progress: course.crs_progress,
            showLikeMenu: true,
            btnAction: () => course?.product_type === "learningpath" ? goToLPDetailUtil(course, navigate, 0) : redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
            descAction: () => course?.product_type === "learningpath" ? goToLPDetailUtil(course, navigate, 0) : redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
            bannerAction: () => course?.product_type === "learningpath" ? goToLPDetailUtil(course, navigate, 0) : redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
            footerLineComp: "",
            showHeader: true,
            showBody: course.short_description ? true : false,
            showFooter: true,
            showProgress: false,
            cardClassName: "",
            rightBtnIcon: "/images/arrow-right.svg",
            lefttBtnIcon: "",
            priceInfo,
            showThumbnail: "0",
            status: course.crs_status,
            asset_type: course?.product_type === "learningpath" ? "Action Path" : course.asset_name,
            duration: course.duration,
            isCalculator: true,
            cate: course?.categories ? course?.categories[0]?.name : "",
            monitoring_name: course?.monitoring_name || "",
            asset_icon: course?.asset_icon,
            monitoring_icon: course?.monitoring_icon,
            isCoachPick:course?.is_coachpick
          });
        }
        if(from === 'explore'){
          prodArr = prodArr.slice(0,3)
        }
        setCalcData(prodArr);
      }
    } catch (error) {
      console.error('error while getting calculator data', error)
    }
    finally {
      setIsLoading(false)
    }
  }
  return (
    <>
    {
      calcData.length > 0 ?
        calcData.map((course, i) => {
          console.log("COURSE334454", course);
          return (
            <div className="col-md-4 col-sm-6 col-12 mb-4 gap-3">
             
                  <ProductCardFinwell
                    {...course}
                    key={`course-${i + 1}`}
                  />
               
            </div>
          );
        })
        :
          <>
            { from !== 'explore' && <NotFoundComponent showMsg={true} />}
          </>
    }
    </>
  )
}

export default CalculatorCard